/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, UseMutationOptions } from '@tanstack/react-query';

import type {
  BboDeclarationBadRequestResponse,
  BboDeclarationFailureResponseResponse,
  ForbiddenResponse,
  MonthlyStatement,
  MonthlyStatementResponseResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary Create Monthly Balance Statement, Monthly Balance Print Receipt in the S3 bucket, Create Monthly Balance Statement in the dynamoDB
 */
export const createMbStatement = (monthlyStatement: MonthlyStatement) => {
  return customInstance<MonthlyStatementResponseResponse>({
    url: `/bm-declaration-service/v1/monthly-balance-statement`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: monthlyStatement,
  });
};

export const getCreateMbStatementMutationOptions = <
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMbStatement>>,
    TError,
    { data: MonthlyStatement },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMbStatement>>,
  TError,
  { data: MonthlyStatement },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMbStatement>>,
    { data: MonthlyStatement }
  > = (props) => {
    const { data } = props ?? {};

    return createMbStatement(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMbStatementMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMbStatement>>
>;
export type CreateMbStatementMutationBody = MonthlyStatement;
export type CreateMbStatementMutationError = ErrorType<
  | BboDeclarationBadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | BboDeclarationFailureResponseResponse
>;

/**
 * @summary Create Monthly Balance Statement, Monthly Balance Print Receipt in the S3 bucket, Create Monthly Balance Statement in the dynamoDB
 */
export const useCreateMbStatement = <
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMbStatement>>,
    TError,
    { data: MonthlyStatement },
    TContext
  >;
}) => {
  const mutationOptions = getCreateMbStatementMutationOptions(options);

  return useMutation(mutationOptions);
};
